import { ClientConfig } from '../config/ClientConfig'
import { LogManager } from '../LogManager'
import { AuthService } from './AuthService'
import { HttpService } from '../services/http-service'

export type MfaType = 'OneTimePassword' | undefined

export type MfaTypeResponse = { type: MfaType }

export const MfaService = new (class {
	private baseURL: string = ClientConfig.POK_USER_API_URL

	async getMfaType(): Promise<MfaType> {
		const userId = await AuthService.getCurrentUserId()
		const url = `${this.baseURL}/user/${userId}/mfa`
		const response = await HttpService.get<MfaTypeResponse | string>(url, {
			authenticate: true,
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
		})
		try {
			const parsed = typeof response === 'string' ? JSON.parse(response) : response
			return parsed.type
		} catch (e) {
			LogManager.warn(`Failed to parse MFA response for userId ${userId}: ${e}`)
			return undefined
		}
	}

	async enableMfa(type: MfaType) {
		const userId = await AuthService.getCurrentUserId()
		const url = `${this.baseURL}/user/${userId}/mfa/enable`
		return await HttpService.post(url, { type: type }, { authenticate: true })
	}

	async disableMfa() {
		const userId = await AuthService.getCurrentUserId()
		const url = `${this.baseURL}/user/${userId}/mfa/disable`
		return await HttpService.post(url, {}, { authenticate: true })
	}
})()
